// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HiddenShop_style_wrapper__28th_","right":"HiddenShop_style_right__Z9i8M","title":"HiddenShop_style_title__31MHt","desc":"HiddenShop_style_desc__1eszq"};